<template>
  <div class="cooperate">
    <div class="seach">
      <el-row>
        <el-button round type="primary" @click="addLockCourse()">表单控件管理</el-button>
      </el-row>
    </div>
    <!-- //表格内容 -->
    <div class="content-wrapper">
      <div class="content-info">
        <el-row class="mt20">
          <div class="seach-list iblock">
            <el-select
              class="input-v"
              v-model="search.keywords"
              filterable
              clearable
              remote
              reserve-keyword
              :remote-method="remoteMethod"
              @change="seachStatus"
              placeholder="请输入或者选择课程"
              style="width:100%;"
            >
              <el-option
                v-for="(item,index) in courseData"
                :key="index"
                :label="item.course_name"
                :value="item.course_id"
              ></el-option>
            </el-select>
          </div>
          <el-button class="r vm" type="primary" :disabled="exportStatus" @click="inportData()">导出本节数据</el-button>
        </el-row>
        <el-table
          ref="table"
          stripe
          :data="tableData.list"
          :header-cell-style="{backgroundColor:'#f5f7fa'}"
          style="width: 100%;margin: 10px 0;"
        >
          <el-table-column
            v-for="(item,index) in tableHeader"
            :key="index"
            :prop="String(index)"
            :label="item"
          ></el-table-column>
        </el-table>
      </div>
      <!-- 分页 -->
      <div class="tc mt20">
        <el-pagination
          background
          @current-change="handleCurrentChange"
          :current-page="Number(search.page)"
          :page-size="Number(search.size)"
          layout="total, prev, pager, next"
          :total="Number(tableData.count)"
        ></el-pagination>
      </div>
    </div>
  </div>
</template>


<script>
import { _userRegistration } from "@/api/user";

import { _getAllCourseList } from "@/api/course";

export default {
  created() {
    this.initInfoList();
    this.initCouresList();
  },
  props:{
    form_type:{
        type:Number
    }
  },
  computed:{
    exportStatus(){
      if((this.search.keywords!='')&&this.tableData.list.length>0){
       return false;
      }else{
        return true
      }
    }
  },
  data() {
    return {
      search: {
        page: 1,
        size: 10,
        keywords: ""
      },
      singleCourseData: [],
      courseData: [],
      tableData: {
        list:[],
        count:''
      },
      tableHeader: []
    };
  },
  methods: {
    remoteMethod(query){
      this.initCouresList(query);
    },
    inportData() {
      if(this.search.keywords&&this.tableData.list.length>0){
         window.open(`/admin/excel/collect?course_id=${this.search.keywords}`,'_self')
      }
    },
    addLockCourse() {
      let routeData = this.$router.resolve({
        path: "/user/add-lockcourse",
        params: {}
      });
      window.open(routeData.href, "_blank");
    },
    seachStatus(val) {
      this.search.page=1;
      this.initInfoList();
    },
    // 请求求合作内容的列表
    initInfoList() {
        // form_mode: 1,锁定课程，2，求合作的表单
      let data = {
        page: this.search.page,
        size: this.search.size,
        form_mode: this.form_type,
        course_id: this.search.keywords
      };
      if (!data.course_id) {
        delete data.course_id;
      }
      _userRegistration({
        params: data
      }).then(res => {
        // console.log(res);
        if (res.resultCode == 1) {
          var data = { ...res.result };
          let titles = data.titles;
          let values = data.values;
          this.tableHeader=titles.map(item=>{
            return item.form_control_name;
          })

          let info = values.map(item => {
            let newItem = titles.map(tit => {
              if (Array.isArray(tit)) {
                return "--";
              }
              return item[Number(tit.form_control_id)]
                ? item[Number(tit.form_control_id)]
                : "--";
            });
            return newItem;
          });
          this.tableData.list = info;
          this.tableData.count=res.result.count
        } else {
          this.$message.error(res.errorMsg);
        }
      });
    },
    //加载课程列表
    initCouresList(keywords) {
      keywords?keywords:keywords=''
      _getAllCourseList({
        params: {
          page:1,
          size:10,
          keywords:keywords
        }
      }).then(res => {
        // console.log(res);
        if (res.resultCode == 1) {
          this.courseData = res.result.list;
        } else {
          tiis.$message.error(res.errorMsg);
        }
      });
    },
    handleCurrentChange(val) {
      // console.log(val);
      this.search.page=val;
      this.initInfoList();
    }
  }
};
</script>


<style lang="less" scoped>
.seach {
  .seach-list {
    .input-v {
      margin-right: 20px;
    }
    .input-sea {
      margin-left: 20px;
      width: 280px;
      border-radius: 5px;
    }
  }
}
</style>